var map = {
	"./map-menu-0@2x.png": "983b",
	"./map-menu-1@2x.png": "0518",
	"./map-menu-2@2x.png": "d499",
	"./map-menu-3@2x.png": "8106",
	"./map-menu-4@2x.png": "c39f",
	"./map-menu-5@2x.png": "f9cc",
	"./map-menu-6@2x.png": "6303",
	"./map-menu-7@2x.png": "f1ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "995e";